import mobileAppCreateComponent from './mobile_app.create.component';

let mobileAppCreateModule = angular.module('mobileAppCreate', [
])

    .component('mobileAppCreate', mobileAppCreateComponent)

    .name;

export default mobileAppCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/mobile_app/create/index.js